module.exports = __webpack_public_path__ + "img/shareBg.bdc5ba20.png";